import { Component, OnInit, Injectable } from '@angular/core';
import { AlertService } from '../../../shared/alert/services/alert.service';
import { UrlService } from '../../../shared/services/url.service';
import { PageLastScore } from '../../models/PageLastScore';
import { WebVitalsService } from '../../services/WebVitals.service';



@Component({
  selector: 'app-webVitalsList',
  templateUrl: '../templates/webVitalsList.component.html'
})

@Injectable()
export class WebVitalsListComponent implements OnInit {

  title = 'Web Vitals';
  DashboardUrl = '';
  inProgress = true;
  scores: PageLastScore[] = [];

  constructor(
    private urlService: UrlService,
    private webVitalsService: WebVitalsService,
    private alertService: AlertService) {
  }

  ngOnInit() {
    this.Init();
    this.webVitalsService.Get().subscribe(scores => {
      this.scores = scores.sort((a, b) => b.actualScore - a.actualScore);
      this.inProgress = false;
    });
  }
  
  Init(): void {
    this.DashboardUrl = this.urlService.GetDashboardRoute();
  };
 
  getRowColorClass(score: PageLastScore) {
    if (score.actualScore < score.minScore) {
      return 'danger';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/webVitals/components/scripts/webVitalsList.component.ts